import React, { useRef } from "react";
import { UseEmblaCarouselType } from "embla-carousel-react";
import { NextButton, PrevButton, usePrevNextButtons } from "./EmblaCarouselArrowButtons";
import { useAutoplay } from "./EmblaCarouselAutoplay";
import { useAutoplayProgress } from "./EmblaCarouselAutoplayProgress";
import "./embla.css";

type PropType = {
	slides: React.ReactNode;
	emblaRef: UseEmblaCarouselType[0];
	emblaApi: UseEmblaCarouselType[1];
	useDefaultButtons: boolean;
};

const EmblaCarousel = (props: PropType) => {
	const { slides, emblaApi, emblaRef } = props;

	// for using the default buttons
	const progressNode = useRef<HTMLDivElement>(null);
	const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
		usePrevNextButtons(emblaApi);
	const { autoplayIsPlaying, toggleAutoplay, onAutoplayButtonClick } = useAutoplay(emblaApi);
	const { showAutoplayProgress } = useAutoplayProgress(emblaApi, progressNode);

	return (
		<div className="embla mt-3 mx-4">
			<div className="embla__viewport" ref={emblaRef}>
				<div className="embla__container">{slides}</div>
			</div>

			{props.useDefaultButtons && (
				<div className="embla__default__controls__container">
					<div className="embla__default__buttons__container">
						<PrevButton
							onClick={() => onAutoplayButtonClick(onPrevButtonClick)}
							disabled={prevBtnDisabled}
						/>
						<NextButton
							onClick={() => onAutoplayButtonClick(onNextButtonClick)}
							disabled={nextBtnDisabled}
						/>
					</div>

					<div
						className={`embla__progress`.concat(
							showAutoplayProgress ? "" : " embla__progress--hidden"
						)}>
						<div className="embla__progress__bar" ref={progressNode} />
					</div>

					<button className="embla__default__play" onClick={toggleAutoplay} type="button">
						{autoplayIsPlaying ? "Stop" : "Start"}
					</button>
				</div>
			)}
		</div>
	);
};

export default EmblaCarousel;
